import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  model,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CompanyInterface } from '@app/interface/company';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogData } from '@app/new-company/new-company.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'izy-confirm-invoice-company-data-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  standalone: true,
  templateUrl: './confirm-invoice-company-data-dialog.component.html',
  styleUrl: './confirm-invoice-company-data-dialog.component.scss',
})
export class ConfirmInvoiceCompanyDataDialogComponent {
  confirmed = false;
  c_f: string = '';
  iva_number: string = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmInvoiceCompanyDataDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      c_f: string;
      iva_number: string;
    }
  ) {
    this.c_f = data.c_f;
    this.iva_number = data.iva_number;
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
